import { render, staticRenderFns } from "./Slogan.vue?vue&type=template&id=6c02d514&scoped=true&"
var script = {}
import style0 from "./Slogan.vue?vue&type=style&index=0&id=6c02d514&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c02d514",
  null
  
)

export default component.exports